/**
 * Recomputes the delivery timeline dates from the shopper's own today (the Liquid dates are the
 * render-time fallback, and cached pages can be a day behind). Offsets are calendar days.
 */
function formatDate(/** @type {Date} */ date, /** @type {string} */ locale) {
  try {
    return new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' }).format(date);
  } catch {
    return date.toDateString();
  }
}

function addDays(/** @type {number} */ days) {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
}

for (const timeline of document.querySelectorAll('[data-delivery-timeline]')) {
  if (!(timeline instanceof HTMLElement) || timeline.dataset.ready) continue;
  timeline.dataset.ready = 'true';
  const locale = timeline.dataset.locale || document.documentElement.lang || 'en';
  const approval = Number(timeline.dataset.approvalDays) || 0;
  const min = Number(timeline.dataset.minDays) || 0;
  const max = Number(timeline.dataset.maxDays) || min;

  for (const node of timeline.querySelectorAll('[data-offset]')) {
    if (!(node instanceof HTMLElement)) continue;
    const offset = node.dataset.offset;
    if (offset === 'delivery') {
      node.textContent = `${formatDate(addDays(min), locale)} – ${formatDate(addDays(max), locale)}`;
    } else {
      const date = addDays(offset === 'approval' ? approval : 0);
      node.textContent = formatDate(date, locale);
      if (node instanceof HTMLTimeElement) node.dateTime = date.toISOString().slice(0, 10);
    }
  }
}
